var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidiSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3875 0C42.2038 0 42.8785 0.599577 42.9853 1.37749L43 1.59375V32.4063C43 33.2131 42.3934 33.8799 41.6063 33.9855L41.3875 34H1.6125C0.796154 34 0.121495 33.4004 0.0147203 32.6225L0 32.4063V1.59375C0 0.786897 0.606631 0.120082 1.39369 0.0145497L1.6125 0H41.3875ZM3.225 18.0604H8.6H11.825H16.125H19.35H23.65H26.875H31.175H34.4H39.775V30.8125H3.225V18.0604ZM3.225 3.18746H39.775V14.8728H3.225V3.18746Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 26.027V18.0604H31.175V26.027L31.1897 26.2432C31.2965 27.0211 31.9712 27.6207 32.7875 27.6207C33.6781 27.6207 34.4 26.9072 34.4 26.027Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 26.027V18.0604H23.65V26.027L23.6647 26.2432C23.7715 27.0211 24.4462 27.6207 25.2625 27.6207C26.1531 27.6207 26.875 26.9072 26.875 26.027Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 26.027V18.0604H16.125V26.027L16.1397 26.2432C16.2465 27.0211 16.9212 27.6207 17.7375 27.6207C18.6281 27.6207 19.35 26.9072 19.35 26.027Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 26.027V18.0604H8.6V26.027L8.61472 26.2432C8.72149 27.0211 9.39615 27.6207 10.2125 27.6207C11.1031 27.6207 11.825 26.9072 11.825 26.027Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1375 7.43321C10.0281 7.43321 10.75 8.14676 10.75 9.02696C10.75 9.90716 10.0281 10.6207 9.1375 10.6207C8.24694 10.6207 7.525 9.90716 7.525 9.02696C7.525 8.14676 8.24694 7.43321 9.1375 7.43321Z",
    fill: "#4860AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7875 7.43517C33.6781 7.43517 34.4 8.14872 34.4 9.02892C34.4 9.83577 33.7934 10.5026 33.0063 10.6081L32.7875 10.6227H27.4125C26.5219 10.6227 25.8 9.90912 25.8 9.02892C25.8 8.22207 26.4066 7.55525 27.1937 7.44972L27.4125 7.43517H32.7875Z",
    fill: "#4860AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5875 7.43732C16.4781 7.43732 17.2 8.15086 17.2 9.03107C17.2 9.91127 16.4781 10.6248 15.5875 10.6248C14.6969 10.6248 13.975 9.91127 13.975 9.03107C13.975 8.15086 14.6969 7.43732 15.5875 7.43732Z",
    fill: "#943939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidiSharing);
export default __webpack_public_path__ + "static/media/midi-sharing.f03c8b9de07a0f38133ea38549f978ff.svg";
export { ForwardRef as ReactComponent };